import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export type IActivateCustomDomainModalActionProps = {
  store: UrlShortenerModalStore
}

export const ActivateCustomDomainModalAction = observer(
  ({ store }: IActivateCustomDomainModalActionProps) => {
    const { handleActivate, handleSuccessCreateCustomDomain, loading } = store

    return (
      <>
        <Button
          typeBtn={'contained'}
          contained={'secondary'}
          text={'Back'}
          onClick={handleSuccessCreateCustomDomain}
        />

        <Button
          typeBtn={'contained'}
          contained={'primary'}
          text={'Activate'}
          onClick={handleActivate}
          disabled={loading}
          loading={loading}
        />
      </>
    )
  }
)
